<template>
  <div class="page-block services-title" id="services-block">
    <div class="wide">
      <div class="mid">
        <div class="titvid">
          <div class="video">
            <div class="grayscale">
              <video
                class="gvid"
                loop
                muted
                playsinline
                autoplay
              >
                <source src="@/content/balls-mini.mp4">
              </video>
            </div>
            <video
              class="vid"
              id="video1"
              loop
              muted
              playsinline
              autoplay
            >
              <source src="@/content/balls-mini.mp4">
            </video>
            <!-- <div class="play">
              <img src="@/i/services/play.svg" />
            </div> -->
          </div>
          <div class="title">
            <!-- <div id="bm-service"></div> -->
            <lottie
              id="bm-service"
              :options="defaultOptions"
              v-on:animCreated="handleAnimation"
            />
            <h2>{{ $t('ServicesBlock.Title') }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lottie from '@/bm/lottie.vue';
import * as animationData from '@/bm/service/data.json';

export default {
  name: 'service-title',
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      defaultOptions: {animationData: animationData.default},
      animationSpeed: 1
    }
  },
  props: {
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    },

  },
  mounted () {
  }
}
</script>
